const selectedOutcomes = {
    title: 'Example JSON',
    expectedOutput: '412499.99999999994',
    initialDisplayedCode: `{
	"selectedOutcomes": [{
		"id": 100,
		"odds": 1100,
		"nrOfPermutations": 0,
		"betOfferId": 1234578
	},
	{
		"id": 101,
		"odds": 1200,
		"nrOfPermutations": 0,
		"betOfferId": 3456789
	}],
	`,
    moreCode: `
	"betBuilders": [],
	"betOffers": [],
	"hasSelectedTeaser": false,
	"selectedTab": "combination",
	"stakes": [{
		"stake": 1,
		"outcomeId": 100,
		"toWinInput": 100,
		"eachWaySelected": true,
		"type": "combination"
	}],
	"selectedReward": {}
}`,
};

export default selectedOutcomes;
